var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tag-select"},_vm._l((_vm.listNew),function(item){return _c('div',{key:item.key,staticClass:"tag-item"},[_c('el-tag',{attrs:{"size":"medium","effect":_vm.getEffect(item.selected)},on:{"click":function($event){return _vm.onClickTag(item)}}},[_vm._v(_vm._s(item.label))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }